import { constants } from "redux/constants/redux-constants";

export const setLicense = (payload) => {
  return { type: constants?.LICENSE?.PACKAGE, payload };
};

export const setPlanStatus = (payload) => {
  return { type: constants?.LICENSE?.PLAN_STATUS, payload };
};

export const setUsersLimit = (payload) => {
  return { type: constants?.LICENSE?.SET_USERS_LIMIT, payload };
};